 
import { BadgeCheck, ShieldCheck, Zap } from "lucide-react";

const TrustBadges = () => (
    <div className="bg-white rounded-2xl p-4 border border-blue-50 shadow-sm">
        <div className="flex items-center justify-around text-center">
            {[
                { Icon: ShieldCheck, label: 'Secure', sub: 'SSL Encrypted', bg: 'bg-blue-50', color: 'text-blue-600' },
                { Icon: Zap, label: 'Fast', sub: 'Instant Booking', bg: 'bg-indigo-50', color: 'text-indigo-600' },
                { Icon: BadgeCheck, label: 'Verified', sub: '100% Safe', bg: 'bg-sky-50', color: 'text-sky-600' },
            ].map(({ Icon, label, sub, bg, color }, i, arr) => (
                <div key={label} className={`flex-1 flex flex-col items-center gap-1 ${i < arr.length - 1 ? 'border-r border-slate-100' : ''}`}>
                    <div className={`w-9 h-9 ${bg} rounded-full flex items-center justify-center`}>
                        <Icon className={`h-[18px] w-[18px] ${color}`} />
                    </div>
                    <span className="text-xs font-bold text-slate-700">{label}</span>
                    <span className="text-xs text-slate-400">{sub}</span>
                </div>
            ))}
        </div>
    </div>
);

export default TrustBadges;
